/**
 * @flow weak
 */


// Consts
export const ON_YOUR_ORDER_MOUNT = 'ON_YOUR_ORDER_MOUNT';
export const ON_YOUR_ORDER_SUCCESS = 'ON_YOUR_ORDER_SUCCESS';
export const ON_YOUR_ORDER_ERROR = 'ON_YOUR_ORDER_ERROR';
export const YOUR_ORDER_CANCEL_ORDER = 'YOUR_ORDER_CANCEL_ORDER';
export const YOUR_ORDER_CANCEL_ORDER_SUCCESS = 'YOUR_ORDER_CANCEL_ORDER_SUCCESS';
export const YOUR_ORDER_CANCEL_ORDER_ERROR = 'YOUR_ORDER_CANCEL_ORDE_ERROR';

// Actions
export const onYourOrderInit = (id) => {
  return {
    type: ON_YOUR_ORDER_MOUNT,
    id
  };
};


//
// Cancel Order actions
//
export const cancelOrder = () => {
  return {
    type: YOUR_ORDER_CANCEL_ORDER
  };
};



// WEBPACK FOOTER //
// ./src/modules/your-order/actions.js